import { AnalyticsActionTypes, BasketActionTypes, ListerActionTypes, ProductActionTypes, SessionActionTypes, } from './../../enums/ActionEnums';
import { default as logger } from '@redux-beacon/logger';
import { createMiddleware } from 'redux-beacon';
import { Criteo } from '@as-react/redux-beacon-criteo';
import { Environment } from '@as-react/common-utils';
import { generateCriteoImpressionEventFromConfirmation, generateCriteoProductId, generateCriteoProductIds, generateCriteoProductImpressionEventFromBasketProducts, generateCriteoUserData, } from '../../util/AnalyticsUtil';
export const analyticsCriteoMiddleware = createMiddleware({
    [ListerActionTypes.LISTER_INIT]: (_action, prevState) => generateCriteoProductIds(prevState.lister.items),
    [ProductActionTypes.INIT]: (_action, prevState) => generateCriteoProductId(prevState.product.productId),
    [SessionActionTypes.SET]: (action) => generateCriteoUserData(action.payload),
    [AnalyticsActionTypes.ANALYTICS_GOOGLE_CONFIRMATION_PAGE]: (action) => generateCriteoImpressionEventFromConfirmation('SITE.data.criteoPageObj', action.payload),
    [BasketActionTypes.SET]: (action) => generateCriteoProductImpressionEventFromBasketProducts('dataLayer', action.payload.products),
}, Criteo(), Object.assign({}, (!Environment.isProduction() && { logger })));
export const createDynamicModuleLoaderAnalyticsCriteo = () => ({
    id: 'startup-analytics-criteo',
    middlewares: [analyticsCriteoMiddleware],
});
